module.exports = __webpack_public_path__ + "img/crud-app-vue-js_backend_frontend.43fb50f4.png";